import React from "react";
import { Filter, X } from "lucide-react";
import { SORTS, DEFAULT_EXEC_FILTERS } from "../../lib/execView";

const cls = "bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-200 focus:outline-none focus:border-blue-500 min-w-[150px]";

function Pick({ id, label, value, onChange, options, all = "All" }) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[10px] uppercase tracking-widest text-slate-500">{label}</span>
      <select className={cls} value={value} onChange={(e) => onChange(e.target.value)} data-testid={`exec-filter-${id}`}>
        {all !== null && <option value="">{all}</option>}
        {options.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </label>
  );
}

export default function ExecFilters({ filters, onChange, portfolios, programs, pms }) {
  const set = (k) => (v) => onChange({ ...filters, [k]: v });
  const pf = portfolios.find((p) => p.id === filters.portfolio);
  const progOptions = programs.filter((p) => !pf || (pf.selected_programs || []).includes(p.id));
  const active = filters.portfolio || filters.program || filters.pm;
  return (
    <div className="pc-card p-4 mb-4 flex flex-wrap items-end gap-3" data-testid="exec-filters">
      <Filter size={16} className="text-blue-400 mb-2.5" />
      <Pick id="portfolio" label="Portfolio" value={filters.portfolio} onChange={(v) => onChange({ ...filters, portfolio: v, program: "" })}
        options={portfolios.map((p) => ({ v: p.id, l: p.name }))} all="All portfolios" />
      <Pick id="program" label="Program" value={filters.program} onChange={set("program")}
        options={progOptions.map((p) => ({ v: p.id, l: p.name }))} all="All programs" />
      <Pick id="pm" label="Project manager" value={filters.pm} onChange={set("pm")}
        options={[...pms.map((p) => ({ v: p.id, l: p.name })), { v: "_unassigned", l: "Unassigned" }]} all="All PMs" />
      <Pick id="sort" label="Sort by" value={filters.sort} onChange={set("sort")} options={SORTS} all={null} />
      {active && (
        <button onClick={() => onChange({ ...DEFAULT_EXEC_FILTERS, sort: filters.sort })} data-testid="exec-filters-clear"
          className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-white mb-2">
          <X size={14} /> Clear filters
        </button>
      )}
    </div>
  );
}
